const mansionGalleryFlow = (() => {
  const pageMansionGallery = (document.getElementById("pageMansionGallery") != null);
  if (pageMansionGallery) {



    let sW = window.innerWidth;

    const secFlow = document.querySelector('#jsSecFlow');
    const flowWrap = secFlow.querySelector('.js-flow-wrap');

    const imgArea = flowWrap.querySelector('.js-img-area');
    const imgBox = imgArea.querySelector('.js-img-box');
    const imgs = imgArea.querySelectorAll('.js-img');

    const btnL = imgArea.querySelector('.js-arw-btn-l');
    const btnR = imgArea.querySelector('.js-arw-btn-r');

    const copyArea = flowWrap.querySelector('.js-copy-area');
    const lineBox = copyArea.querySelector('.js-line-box');
    const line = copyArea.querySelector('.js-line-box span');
    const copyBox = copyArea.querySelectorAll('.js-copy-box');


    if (sW > 750) {
      {
        let to = gsap.to(imgBox, {
          ease: "none",
          scrollTrigger: {
            trigger: imgBox,
            start: '50% 50%',
            endTrigger: secFlow,
            end: '100% 100%',
            pin: true,
            // markers: true
          }
        })

        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            to.scrollTrigger.refresh()
            // console.log('comParallax refresh');
          });
        });
        observer.observe(target);
      }
    }


    {
      imgs.forEach((element, index) => {
        if (!index == 0) {

          let to = gsap.to(element, {
            ease: "none",
            scrollTrigger: {
              trigger: copyBox[index],
              start: '0% 50%',
              endTrigger: 'body',
              end: '100% 0%',
              onEnter: () => {
                element.classList.add('act')
                copyBox[index].classList.add('act')
              },
              // onLeave: () => console.log("onLeave"),
              // onEnterBack: () => console.log("onEnterBack"),
              onLeaveBack: () => {
                element.classList.remove('act')
                copyBox[index].classList.remove('act')
              },
              // markers: true
            }
          })

          let target = document.querySelector('body');
          let observer = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
              to.scrollTrigger.refresh()
              // console.log('comParallax refresh');
            });
          });
          observer.observe(target);

        }
      });
    }


    {
      btnL.addEventListener('click', (event) => {
        event.preventDefault();
        let sH = window.innerHeight;
        let targetCheck = copyArea.querySelectorAll('.js-copy-box.act');
        let targetElement
        if (targetCheck.length <= 1) {
          targetElement = copyBox[targetCheck.length - 1]
        } else {
          targetElement = copyBox[targetCheck.length - 2]
        }
        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = sH * 0.5 - 2;
        const target = rect + offset - gap;
        window.scrollTo({
          top: target,
          behavior: 'smooth',
        });
      });

      btnR.addEventListener('click', (event) => {
        event.preventDefault();
        let sH = window.innerHeight;
        let targetCheck = copyArea.querySelectorAll('.js-copy-box.act');
        let targetElement
        if (targetCheck.length >= 6) {
          targetElement = copyBox[targetCheck.length - 1]
        } else {
          targetElement = copyBox[targetCheck.length - 0]
        }
        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = sH * 0.5 - 2;
        const target = rect + offset - gap;
        window.scrollTo({
          top: target,
          behavior: 'smooth',
        });
      });
    }


    {
      let lineBoxH = lineBox.clientHeight;

      let to = gsap.to(line, {
        height: lineBoxH,
        ease: "none",
        scrollTrigger: {
          trigger: copyBox[0],
          start: '0% 50%',
          endTrigger: copyBox[copyBox.length - 1],
          end: '0% 50%',
          scrub: 0,
          // markers: true
        }
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    }



  }
})()
export default mansionGalleryFlow;